import { IRawStyle } from "@fluentui/react";
import React from "react";

import { SprintAccessRight } from "../../../core/security/SprintAccessRight";
import { NoteSubjectType } from "../../types/NoteSubjectType";
import { NotesSection } from "./components/NotesSection";
import { NoteItem } from "./hooks/state/NoteItem";
import { NotesStateProvider } from "./hooks/state/NotesStateProvider";

interface NotesProps {
    subjectId: string;
    sourceIds: string[];
    subjectType: NoteSubjectType;
    style?: IRawStyle;
    isDeleteSupported?: boolean;
    isHeader?: boolean;
    isInlineCreateSupported?: boolean;
    defaultNotes?: NoteItem[];
    accessRights: SprintAccessRight[];
    disabled?: boolean;
    renderBadge?: (note: NoteItem) => JSX.Element;
}

export const Notes: React.FC<NotesProps> = ({
    subjectId,
    sourceIds,
    style,
    isInlineCreateSupported,
    isHeader,
    isDeleteSupported,
    defaultNotes,
    subjectType,
    accessRights,
    disabled,
    renderBadge
}: NotesProps) => {
    return (
        <NotesStateProvider
            subjectType={subjectType}
            subjectId={subjectId}
            sourceIds={sourceIds}
            isDeleteSupported={isDeleteSupported ?? false}
            isHeader={isHeader ?? true}
            isInlineCreateSupported={isInlineCreateSupported ?? false}
            style={style}
            defaultNotes={defaultNotes}
            accessRights={accessRights}
            disabled={disabled}
            renderBadge={renderBadge}
        >
            <NotesSection />
        </NotesStateProvider>
    );
};
